/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const Q_bleeding = require('./Q_bleeding');
const UseAbility = require('../UseAbility');

const Q_nearby_enemy = function (actor, battleState, buffNode) {
  const node = new YesNoNode(actor, battleState);

  node.HOLY_FORCE = 5;

  node.holyForce = BattleCalc.getEquippedAbility(actor, 'holy_force');

  node.branches[node.NO] = new Q_bleeding(actor, battleState, buffNode);

  if (node.holyForce) {
    node.branches[node.YES] = new UseAbility(actor, 'holy_force');
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.holyForce = null;
    originalDispose.call(node);
  };

  node.query = function (target) {
    if (this.yesNoEvalFunction()) {
      return this.branches[this.YES].query(this.actor); // holy force - self cast
    } else {
      return this.branches[this.NO].query(target);
    }
  };

  node.yesNoEvalFunction = function () {
    if (!this.holyForce) {
      return false;
    }

    return (
      BattleCalc.boardDistance(
        this.actor,
        this.battleState.getNearestEnemyOf(this.actor)
      ) <= this.holyForce.effectRange &&
      this.actor.lastAbilityExecuted != 'holy_force'
    );
  };

  return node;
};
module.exports = Q_nearby_enemy;
